const aminoAcidToDegenerateRnaMap = {
  "-": "---",
  ".": "...",
  "*": "trr",
  a: "gcn",
  b: "ray",
  c: "ugy",
  d: "gay",
  e: "gar",
  f: "uuy",
  g: "ggn",
  h: "cay",
  i: "auh",
  j: "hun",
  k: "aar",
  l: "yun",
  m: "aug",
  n: "aay",
  o: "uag",
  p: "ccn",
  q: "car",
  r: "mgn",
  s: "wsn",
  t: "acn",
  u: "uga",
  v: "gun",
  w: "ugg",
  x: "nnn",
  y: "uay",
  z: "sar"
};
export default aminoAcidToDegenerateRnaMap;
